var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Filters", {
        on: {
          iut: function($event) {
            _vm.filter = $event
          },
          razonSocial: function($event) {
            _vm.filter = $event
          }
        }
      }),
      _c("TransactionalityDetail", { attrs: { filter: _vm.filter } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }